import React from 'react'
import { Container } from './container'
import auth from '../utils/auth'
import LazyLoad from 'react-lazyload'

const SimplePageHeader = ({ title, description, noPadding, largePadding }) => {
  const { isOfficial, isVerified } = auth()

  let padding = noPadding ? '' : 'py-8 lg:py-10'
  const role = isOfficial ? 'official' : isVerified ? 'verified' : ''

  if (largePadding) {
    padding = 'py-8 lg:pt-20 lg:pb-24'
  }

  return (
    <LazyLoad height={'40vh'}>
      <Container
        color="#BB3B36"
        className={`page-header ${padding} ${role} bg-center bg-cover bg-no-repeat`}
        style={{backgroundImage: `url('/images/bnpt-page-header-background.jpg')`}}
      >
        <div className="flex flex-col items-center justify-center text-center">
          <h1 className="text-3xl lg:text-6xl text-white uppercase">{title}</h1>
          {
            description &&
            <div className="w-full lg:w-8/12 mx-auto">
              <p className="mt-4 lg:mt-5 text-white lg:text-lg">{description}</p>
            </div>
          }
        </div>
      </Container>
    </LazyLoad>
  )
}

export { SimplePageHeader }
